import {useTheme as useThemeMui} from '@mui/styles';
import type {Theme} from '../types';

export const useTheme = () => useThemeMui<Theme>();
